module.exports = __webpack_public_path__ + "img/empty-project.8c7a1e3d.svg";